// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '@fortawesome/fontawesome-free/css/all.css'
import Notifications from 'vue-notification'
import VModal from 'vue-js-modal'
import { io } from 'socket.io-client';


Vue.use(Notifications);
Vue.use(VModal, { dynamic: true, dialog:true});

const isValidStr = str => typeof str === 'string' && str.length;
let hostOtmLote = process.env.VUE_APP_OTM_LOTE_HOST;
let portOtmLote = process.env.VUE_APP_OTM_LOTE_PORT;
portOtmLote = !portOtmLote || portOtmLote.toLowerCase() === "null" ? null : Number(portOtmLote);
let hostPortAlgoritmo = process.env.VUE_APP_HOST_ALGORITMO_SERVER;
let socketUrl = hostOtmLote;

if(isValidStr(hostOtmLote)){ 
	hostOtmLote = hostOtmLote.replace(/\/+$/gi, ''); // remove last bar
}
if(isValidStr(portOtmLote)){
	portOtmLote = portOtmLote.replace(/[^\d]+/gi, ''); // remove characters non numerics
	socketUrl = `${hostOtmLote}:${portOtmLote}`;
}

const SocketInstance = io(socketUrl , {transports: ['websocket']});
const OTM_LOTE_URL = socketUrl;
const getSocketInstance = () => SocketInstance;
const getOtmLoteUrl = () => OTM_LOTE_URL;
const getAlgoritmoHost = () => hostPortAlgoritmo;
export {
	getSocketInstance,
	getOtmLoteUrl,
	getAlgoritmoHost
};

new Vue({
	el: '#app',
	router,
	components: { App },
	template: '<App/>'
})